import apiClient from './config';
import { API_ENDPOINTS } from '../config/api';

export const getPacientes = (params) => apiClient.get(API_ENDPOINTS.PATIENT.LIST, { params });
export const getPacientesSinHistoria = () => apiClient.get(API_ENDPOINTS.PATIENT.SIN_HISTORIA);
export const getPaciente = (id) => apiClient.get(API_ENDPOINTS.PATIENT.DETAIL(id));
export const createPaciente = (data) => apiClient.post(API_ENDPOINTS.PATIENT.CREATE, data);
export const updatePaciente = (id, data) => apiClient.put(API_ENDPOINTS.PATIENT.UPDATE(id), data);
export const buscarPacientePorCedulaSRI = (cedula) => apiClient.get(API_ENDPOINTS.PATIENT.SEARCH_SRI_BY_CEDULA(cedula));
export const getHistoriasClinicas = (pacienteId) => apiClient.get(API_ENDPOINTS.MEDICAL_RECORD.LIST_BY_PATIENT(pacienteId));